<template>
  <div>
    <spinner-round :is-loading="loading < 0 || loadContract"></spinner-round>
    <div
      v-if="(adv || sale) && program && lot && loading === 0 && !loadContract"
      id="adv-wrapper">
      <page-nav-bar
        :is-sticky="true"
        :back-button="true"
        :has-actions="true">
        <template slot="breadcrumb">
          <h1 class="page-header-breadcrumb-item is-uppercase">
            <span class="">
              <router-link
                class="has-cursor-pointer"
                :to="{'name': 'AdvInfos', params: {id: adv.pk}}">
                ADV N° : {{ adv.ref }}
              </router-link>
            </span>
            <span class="has-text-weight-light has-text-grey">
              <router-link
                tag="span"
                class="is-paddingless has-cursor-pointer"
                :to="{'name': 'LotVue', params: {id: lot.pk}}"
                v-if="lot && lot.pk">
                - Lot {{ lot.ref }} -
              </router-link>
              <router-link
                tag="span"
                class="is-paddingless has-cursor-pointer"
                :to="{'name': 'ProgramVue', params: {id: program.pk}}"
                v-if="program && program.pk">
                {{ program.name }}
              </router-link>
            </span>
          </h1>
        </template>
        <template slot="before-actions">
          <a
            @click="approveReserved()"
            v-if="isPromoteur && isAdmin && !adv.is_digital && adv.status === 'pre_reserved'"
            class="page-header-btn is-small is-reserved">
            <span>Passer en réservation</span>
          </a>
          <a
            @click="approveSold()"
            v-if="isPromoteur && isAdmin && adv.status === 'reserved'"
            class="page-header-btn is-small is-sold">
            <span>Passer le lot en vente actée</span>
          </a>
        </template>
        <a
          @click="reloadContract"
          v-if="adv.is_complete"
          class="dropdown-item"
          slot="dropdown-content">
          <span class="icon is-medium">
            <i class="fas fa-sync"></i>
          </span>
          <span class="is-margin-left-xsmall">Ré-générer le contrat</span>
        </a>
        <a
          v-if="isPromoteur && isAdmin && adv.status === 'sold'"
          @click="approveReserved()"
          class="dropdown-item"
          slot="dropdown-content">
          <span class="icon is-medium">
            <i class="fas fa-undo"></i>
          </span>
          <span class="is-margin-left-xsmall">Repasser en réservation</span>
        </a>
        <a
          v-if="isPromoteur && isAdmin && (isExternalConnection() || sageConnector)"
          class="dropdown-item"
          slot="dropdown-content">
          <router-link
            tag="span"
            class="is-paddingless has-cursor-pointer"
            :to="{'name': 'ExternalConnectionHistory'}"
            v-if="program && program.pk">
            <span class="icon is-medium"><i class="fas fa-rss" /></span>
            <span class="is-margin-left-xsmall">Informations d'export</span>
          </router-link>
        </a>
        <a
          v-if="!(isAdmin && isPromoteur)"
          @click="openModalTicket"
          slot="dropdown-content"
          class="dropdown-item">
          <span class="icon is-medium"><i class="fas fa-question"></i></span>
          <span class="is-margin-left-xsmall">Contacter le promoteur</span>
        </a>
        <a
          v-if="isAdmin && isPromoteur && isExternalConnection()"
          @click="SendToTransfer"
          class="dropdown-item"
          slot="dropdown-content">
          <span class="icon is-medium">
            <i class="fas fa-share"></i>
          </span>
          <span class="is-margin-left-xsmall">Envoyer la vente</span>
        </a>
        <a
          v-if="isAdmin && isPromoteur && (isSold || isReserved || isPreReserved)"
          @click="cancelAdv"
          class="dropdown-item has-background-danger has-text-white"
          slot="dropdown-content">
          <span class="icon is-medium">
            <i class="fas fa-trash-alt"></i>
          </span>
          <span
            v-if="isSold"
            class="is-margin-left-xsmall">Annuler la vente</span>
          <span
            v-else
            class="is-margin-left-xsmall">Annuler la réservation</span>
        </a>
        <a
          v-if="sageConnector && adv.sale_date && isAdmin && isPromoteur && (isSold || isReserved)"
          @click="sendSaleSage"
          class="dropdown-item"
          slot="dropdown-content">
          <span class="icon is-medium">
            <!-- <i class="fas fa-rss"></i> -->
            <i class="fas fa-share"></i>
          </span>
          <span class="is-margin-left-xsmall">Envoyer données de vente à Sage</span>
        </a>
      </page-nav-bar>
      <page-content
        :has-no-padd-on-act-on-desktop="false"
        :has-padd-left-on-act="true"
        :has-padd-right-on-act="true"
        :has-left-col-small="false"
        :has-left-col-small-size-fixed="false"
        :has-sticky-col-left="false">
        <tabs
          :links="advTabLinks"
          :level="1"
          :is-fullwidth="true"
          class="has-background-white is-margin-bottom"></tabs>
        <div
          v-if="adv.status === 'canceled'"
          class="is-padding-bottom">
          <div class="notification is-warning has-text-centered is-marginless columns is-multiline">
            <p class="is-uppercase is-size-7 column is-12 is-paddingless">
              <span class="icon"><i class="fas fa-exclamation-circle"></i></span>
              <span class="has-text-weight-medium">Adv annulée <span v-if="adv.canceled_reason && adv.canceled_reason.canceled_date">le {{ adv.canceled_reason.canceled_date }}</span></span>
            </p>
            <span
              v-if="adv.canceled_reason && adv.canceled_reason.canceled_choice_type"
              class="column is-12 is-paddingless has-text-weight-medium is-size-7">Raison : {{ adv.canceled_reason.canceled_choice_type | cancelAdvChoiceLabel }}</span>
            <span
              v-if="adv.canceled_reason && adv.canceled_reason.canceled_imputation_date"
              class="column is-12 is-paddingless has-text-weight-medium is-size-7">Date d'imputation : {{ adv.canceled_reason.canceled_imputation_date | prettyDate }}</span>
            <span
              class="column is-12 is-paddingless has-text-weight-medium is-size-7"
              v-if="adv.canceled_reason && adv.canceled_reason.canceled_comment">
              Commentaire
              <span
                class="inlineblockCancelAdv"
                v-html="`:${adv.canceled_reason.canceled_comment}`"></span>
            </span>
          </div>
        </div>
        <div
          v-else-if="!plan.adv_enabled"
          class="is-padding-bottom">
          <div class="notification is-warning has-text-centered is-marginless">
            <p class="is-uppercase is-size-7">
              <span class="icon"><i class="fas fa-exclamation-circle"></i></span>
              <span class="has-text-weight-medium">Changer d'abonnement pour bénéficier de l'administration des ventes dans sa totalité</span>
            </p>
          </div>
        </div>
        <div
          v-else-if="!adv.promoteur.plan.adv_enabled"
          class="is-padding-bottom">
          <div class="notification is-warning has-text-centered is-marginless">
            <p class="is-uppercase is-size-7">
              <span class="icon"><i class="fas fa-exclamation-circle"></i></span>
              <span class="has-text-weight-medium">Le Promoteur ne bénéficie pas de l'administration des ventes dans sa totalité</span>
            </p>
          </div>
        </div>
        <router-view
          :ref="$route.name"
          :seller="seller"
          :lot="lot"
          :program="program"
          @getAdv="getAdv"
          @getSale="getSale"
          @backToInitialAdv="backToInitialAdv"
          @clickOnReminder="openReminderCreation"></router-view>
        <!-- <cta-to-reminder
          v-if="isAdmin && isPromoteur && canUseCalendar && adv.status !== 'canceled'"
          class="is-sticky--bottom is-margin-left-auto is-margin-right is-margin-top"
          @clickOnCta="openReminderCreation"></cta-to-reminder> -->
        <cta-to-adv
          v-if="!(isAdmin && isPromoteur) && adv.status !== 'canceled'"
          class="is-sticky--bottom is-margin-left-auto is-margin-right is-margin-top"
          @clickOnCta="openModalTicket"></cta-to-adv>
      </page-content>
    </div>
  </div>
</template>

<script>

import { Quickview, FilterGetter, DefaultValues } from '@/mixins'
import { bus, EVENTS } from '@/bus'
import { mapGetters, mapState } from 'vuex'
import { cloneDeep } from 'lodash'
import moment from 'moment'

export default {
  name: 'Adv',
  components: {
    // CtaToReminder: () => import('@/components/utils/CtaToReminder'),
    CtaToAdv: () => import('@/components/utils/CtaToAdv')
  },
  mixins: [Quickview, FilterGetter, DefaultValues],
  data () {
    return {
      loadContract: false,
      loading: 0,
      program: null,
      lot: null,
      seller: null,
      motifCancel: ''
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.pendingSubmit && this.isLog) {
      return this.$swal({
        title: 'Modification ADV',
        text: 'Vous êtes sur le point de quitter cette ADV. Souhaitez-vous enregistrer les modifications avant de quitter l\'ADV ?',
        confirmButtonText: 'Enregistrer et quitter',
        confirmButtonColor: '#81bc74',
        cancelButtonText: 'Quiter sans enregistrer',
        cancelButtonColor: '#ff0200',
        showCloseButton: true
      }).then(async r => {
        if (r.value) {
          // this.$store.dispatch('updateCurrentSale')
          // this.$store.dispatch('updateCurrentAdv')
          // this.$toasted.global.success('Reservation modifiée')
          this.submitLoading = true
          if (this.adv.tax_dispositif == null && this.adv.destination === 'invest') {
            this.$toasted.global.danger('Veuillez renseigner le dispositif associé à la destination.')
            this.submitLoading = false
            return
          } else {
            try {
              if (this.adv.status === 'reserved' || this.adv.status === 'sold') {
                await this.$store.dispatch('updateCurrentSale')
                this.$emit('getSale')
                this.$emit('getAdv')
              } else {
                await this.$store.dispatch('updateCurrentAdv')
                this.$emit('getAdv')
              }
              this.$toasted.global.success('Reservation modifiée')
              this.submitLoading = false
            } catch (e) {
              console.log(e)
              this.submitLoading = false
              this.$toasted.global.danger('Erreur lors de la mise à jour')
              return
            }
          }
          next()
        } else if (r.dismiss === 'cancel') {
          this.backToInitialAdv()
          next()
        }
      })
    } else {
      next()
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isPromoteur', 'canUseElectronicSign', 'canUseBuyerSpace', 'canUseCalendar', 'plan', 'isLog']),
    ...mapState(['currentAdv', 'currentSale', 'pendingSubmit', 'currentAccount']),
    modal () { return this.$store.state.modal },
    commentaire () {
      return this.$store.state.commentaire
    },
    reason () {
      return this.$store.state.reason
    },
    imputationDate () {
      return this.$store.state.imputationDate
    },
    triggerUpdateStatus () {
      return this.$store.state.triggerUpdateStatus
    },
    /**
      * return current adv
      * @returns {object}
      */
    adv () {
      return this.currentAdv
    },
    /**
      * return current sale
      * @returns {object}
      */
    sale () {
      return this.currentSale
    },
    /**
      * return adv pk
      * @returns {string}
      */
    advPk () {
      return this.$route.params.id
    },
    /**
      * adv tabs
      * @returns {array}
      */
    advTabLinks () {
      let tabs = []
      tabs.push({ link: 'AdvInfos', label: 'Information vente' })
      tabs.push({ link: 'ContratDeReservation', name: 'FeuilleDeRoute', label: 'Feuille de route' })
      if ((this.isReserved || this.isSold) && this.isPromoteur && this.isAdmin && !this.programIsDeleted && !this.lotIsDeleted && this.canUseBuyerSpace) {
        tabs.push({ link: 'EspaceAcquereur', label: 'Espace Acquéreur' })
      }
      tabs.push({ link: 'AdvDocuments', label: 'Documents' })
      return tabs
    },
    /**
      * adv has lot
      * @returns {boolean}
      */
    lotIsDeleted () {
      return this.adv.lot === null
    },
    /**
      * adv has program
      * @returns {boolean}
      */
    programIsDeleted () {
      return this.adv.program === null
    },
    /**
      * adv status is reserved
      * @returns {boolean}
      */
    isReserved () {
      return this.adv.status === 'reserved'
    },
    /**
      * adv status is pre_reserved
      * @returns {boolean}
      */
    isPreReserved () {
      return this.adv.status === 'pre_reserved'
    },
    /**
      * adv status is canceled
      * @returns {boolean}
      */
    isCanceled () {
      return this.adv.status === 'canceled'
    },
    /**
      * adv status is sold
      * @returns {boolean}
      */
    isSold () {
      return this.adv.status === 'sold'
    },
    sageConnector () {
      return this.currentAccount.sage_connector
    }
  },
  watch: {
    triggerUpdateStatus: {
      handler: 'onUpdateStatus'
    }
  },
  async created () {
    await this.getAdv()
    await this.getSale()
    try {
      await this.initParkings()
    } catch (e) {
      console.log(e)
    }
    bus.$on(EVENTS.RESERVATION_SIGNED, (data) => {
      if (data.resource_pk === this.advPk) {
        this.getAdv()
        this.getSale()
      }
    })
  },
  destroyed () {
    bus.$off([EVENTS.RESERVATION_SIGNED])
  },
  methods: {
    /**
      * patch parkings
      */
    async patchParkings (parkings) {
      if (this.adv.status !== 'canceled') {
        let payload = {
          parkings: parkings
        }
        try {
          await this.$store.dispatch('patchAdvParkings', payload)
          this.updateMode = false
          this.$toasted.global.success('Parkings mis a jour (détection automatique)')
          this.$emit('getSale')
        } catch (e) {
          console.log(e)
          this.$toasted.error('Erreur lors de la mise à jour')
        }
      }
    },
    initParkings () {
      let needUpdate = false
      let advParkings = cloneDeep(this.adv.parkings)
      let lotParkings = cloneDeep(this.lot.parkings)
      if (lotParkings.length === 0 && advParkings.length !== lotParkings.length) {
        needUpdate = true
        advParkings = lotParkings
      } else {
        for (let parking of advParkings) {
          let lotParking = lotParkings.find(x => x.pk === parking.pk)
          let result = Object.keys(lotParking).every(
            key => parking.hasOwnProperty(key) &&
                    parking[key] === lotParking[key])
          if (!result) {
            needUpdate = true
            const index = advParkings.findIndex(x => x.pk === parking.pk)
            if (index >= 0) {
              advParkings.splice(index, 1, lotParking)
            }
          }
        }
      }
      if (needUpdate) {
        this.patchParkings(advParkings)
      }
    },
    openReminderCreation () {
      let params = {
        noRedirection: true,
        type: 'reminder',
        source: {
          advLink: this.adv.pk,
          programLink: this.adv.program.pk,
          programName: this.adv.program.name,
          advRef: this.adv.ref
        }
      }
      this.openCalendarNewAction(params)
    },
    /**
      * open ticket modal
      */
    openModalTicket () {
      const formatedReferents = this.program.referents.map(x => {
        return {
          ...x,
          picture: x.picture[0]
        }
      })
      if (!(this.isPromoteur && this.isAdmin)) {
        let params = {
          defaultSubject: 'reservation',
          defaultTitle: `ADV ${this.adv.ref} - LOT ${this.adv.lot.ref} - ${this.adv.program.name}`,
          promoteur: this.adv.promoteur.pk,
          referents: formatedReferents || []
        }
        this.$store.commit('setModal', { mode: 'CREATE_TICKET', params })
      }
    },
    /**
      * confirm sold
      */
    async approveSold () {
      let value = await this.$swal({
        title: 'Acter la vente',
        text: 'Cette action entrainera la modification du statut du lot. Le lot et l\'ADV seront indiqués comme Acté. La date de l\'acte sera par défaut la date de cette action. Vous pouvez modifier la date de l\'acte en vous rendant dans l\'onglet Acte de Vente de votre ADV.',
        cancelButtonText: 'Annuler',
        confirmButtonText: 'Valider',
        customClass: {
          confirmButton: 'is-danger'
        }
      })
      if (value.dismiss) return false // ON ne supprimme pas l'utilisateur
      if (value) {
        await this.updateStatus('sold')
      }
    },
    /**
      * reload Contract
      */
    async reloadContract () {
      this.loadContract = true
      try {
        await this.$api.get(this.$resources.REFRESH_CONTRACT(this.advPk))
        this.$store.commit('setCurrentAdvContract', { data: null })
        this.loadContract = false
      } catch (err) {
        console.log(err)
        this.loadContract = false
      }
    },
    /**
      * confirm reserved
      */
    async approveReserved () {
      let value = await this.$swal({
        title: 'Passage en réservation',
        text: 'Cette action entrainera la modification du statut du lot. Le lot et l\'ADV seront indiqués comme Réservé. La date de réservation sera par défaut la date de cette action. Vous pouvez modifier la date de réservation en vous rendant dans l\'onglet Signature de votre ADV.',
        cancelButtonText: 'Annuler',
        confirmButtonText: 'Valider',
        customClass: {
          confirmButton: 'is-danger'
        }
      })
      if (value.dismiss) return false // ON ne supprimme pas l'utilisateur
      if (value) {
        await this.updateStatus('reserved')
      }
    },
    /**
      * cancel adv
      */
    async cancelAdv () {
      let params = {
        procedure: this.adv.pk
      }
      this.$store.commit('setModal', { mode: 'CANCEL_PROCEDURE', params })
    },
    /**
      * update adv status
      */
    async updateStatus (status, reason = null, commentaire = null, imputationDate = null) {
      try {
        const payload = {
          canceled_choice_type: reason,
          canceled_comment: commentaire,
          canceled_date: moment(),
          canceled_imputation_date: imputationDate
        }
        await this.$api.updateReservationStatus(this.advPk, status, payload)
        if (status === 'canceled') {
          this.$toasted.global.success('Adv supprimée')
          this.$router.replace({ name: 'AdvList' })
        } else if (status === 'sold') {
          this.$toasted.global.success('Lot passé en vente actée')
          this.getAdv()
          this.getSale()
        } else {
          this.$toasted.global.success('Lot passé en réservation')
          this.getAdv()
          this.getSale()
        }
      } catch (e) {
        this.$toasted.global.danger('Impossible de mettre à jour la réservation.')
      }
    },
    /**
      * back to initial adv
      */
    backToInitialAdv () {
      this.$store.commit('setAdvSubmitButtons', false)
      this.getAdv()
      this.getSale()
    },
    /**
      * get adv
      */
    async getAdv () {
      this.loading += 1
      try {
        await this.$store.dispatch('getcurrentAdv', this.advPk)
      } catch (err) {
        this.$router.replace({ name: 'NotFound' })
      }
      if (this.adv.lot) {
        try {
          await this.getLot(this.adv.lot.pk)
        } catch (err) {
          this.lot = this.adv.lot_data
          this.lot.deleted = true
        }
      } else {
        this.lot = this.adv.lot_data
        this.lot.deleted = true
      }
      if (this.adv.program) {
        try {
          await this.getProgram(this.adv.program.pk)
        } catch (err) {
          this.program = this.adv.lot_data.program
          this.program.deleted = true
        }
      } else {
        this.program = this.adv.lot_data.program
        this.program.deleted = true
      }
      if (this.adv.user) {
        try {
          await this.getSeller(this.adv.user.pk)
        } catch (err) {
          this.seller = this.adv.seller_data
          this.seller.deleted = true
        }
      } else {
        this.seller = this.adv.seller_data
        this.seller.deleted = true
      }
      this.loading -= 1
    },
    /**
      * get lot
      * @param {string} id - lot pk
      */
    async getLot (id) {
      this.loading += 1
      try {
        let { data } = await this.$api.getOne(this.$resources.LOT, id)
        this.lot = data
      } catch (err) {
        console.log(err)
      } finally {
        this.loading -= 1
      }
    },
    /**
      * get program
      * @param {string} id - program pk
      */
    async getProgram (id) {
      this.loading += 1
      try {
        let { data } = await this.$api.getOne(this.$resources.PROGRAM, id)
        this.program = data
      } catch (err) {
        console.log(err)
      } finally {
        this.loading -= 1
      }
    },
    /**
      * get sellet
      * @param {string} id - seller pk
      */
    async getSeller (id) {
      this.loading += 1
      try {
        let { data } = await this.$api.getOne(this.$resources.USER, id)
        this.seller = data
      } catch (err) {
        console.log(err)
      } finally {
        this.loading -= 1
      }
    },
    /**
      * get sale
      */
    async getSale () {
      this.loading += 1
      const params = {
        reservation: this.advPk,
        per_page: 1
      }
      try {
        await this.$store.dispatch('getcurrentSale', params)
      } catch (err) {
        console.log(err)
      } finally {
        this.loading -= 1
      }
    },
    approveGrConnection () {
      let bool = false
      let grMissing = ''
      if (this.adv.lot_data.external_id === null) {
        grMissing += ' - grimmo lot id'
        bool = true
      }
      if (this.adv.seller_data.external_id === null) {
        bool = true
        grMissing += ' - grimmo seller ' + this.adv.seller_data.first_name + ' ' + this.adv.seller_data.last_name + ' id'
      }
      this.adv.buyers_data.forEach(buyers => {
        if (buyers.external_id === null) {
          grMissing += ' - grimmo buyer ' + buyers.first_name + ' ' + buyers.last_name + ' id'
          bool = true
        }
      })
      this.grMissData = grMissing
      if (this.program.is_amenagement) {
        bool = false
      }
      return bool
    },
    isExternalConnection () {
      if (this.adv.promoteur.external_connection && this.adv.promoteur.external_connection.length) {
        return true
      } else {
        return false
      }
    },
    onUpdateStatus () {
      if (this.triggerUpdateStatus === true) {
        this.updateStatus('canceled', this.reason, this.commentaire, this.imputationDate)
          .then(() => {
            this.$store.commit('setTriggerUpdateStatus', false)
          })
      }
    },
    async SendToTransfer () {
      let payload = {
        reservation_pk: this.adv.pk,
        user_pk: this.currentUser.pk
      }
      let { data } = await this.$api.post(this.$resources.TRANSFER_GR, this.$cleanPayload(payload))
      if (data) {
        this.$toasted.global.success('La vente à été envoyée.')
      }
    },
    async sendSaleSage () {
      let payload = {
        reservation_pk: this.adv.pk,
        user_pk: this.currentUser.pk
      }
      try {
        await this.$api.post(this.$resources.TRANSFER_SAGE, this.$cleanPayload(payload))
        this.$toasted.global.success('La vente à été envoyée.')
      } catch (error) {
        this.$toasted.global.danger('Donnée ref ou société ne doit pas être null.')
      }
    }
  }
}
</script>

<style lang="sass">

.inlineblockCancelAdv>p
  display: inline !important
  margin-left: 5px

.frontdrop
  height: 100%
  position: absolute
  width: 100%
  background-color: #EFF3F6
  opacity: 0.6
  z-index: 10

</style>
